import { Maps } from 'src/types/board';
import * as maps from '../ressources/maps';

const mapToSource = (map: Maps): string => maps[map].img;

export default mapToSource;
